import CommonGridHeader from './CommonGridHeader';

export default CommonGridHeader;
